import { render, staticRenderFns } from "./ModalBoxAdvanced.vue?vue&type=template&id=0a36067a&scoped=true&"
import script from "./ModalBoxAdvanced.vue?vue&type=script&lang=ts&"
export * from "./ModalBoxAdvanced.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBoxAdvanced.vue?vue&type=style&index=0&id=0a36067a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a36067a",
  null
  
)

export default component.exports